import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, useNewsDispatch } from "./news-context";
import { IListNewsRequest } from "../../../model/base/request/list-news-request";

export const useNewsController = () => {
    const NewsDispatch = useNewsDispatch();

    async function loadData(request: IListNewsRequest) {
        try {
            NewsDispatch({
                type: ACTION_TYPES.setLoading,
                payload: true,
            });

            const result = await PortalAppService.listNews(request);

            NewsDispatch({
                type: ACTION_TYPES.setNews,
                payload: result,
            });
        } catch (error) {
            console.error('Erro ao carregar notícias:', error);
            NewsDispatch({
                type: ACTION_TYPES.setLoading,
                payload: false,
            });
        }
    }

    async function loadCategories() {
        try {
            NewsDispatch({
                type: ACTION_TYPES.setLoadingFilters,
                payload: true,
            });

            const categories = await PortalAppService.listNewsCategories();

            NewsDispatch({
                type: ACTION_TYPES.setCategories,
                payload: categories,
            });
        } catch (error) {
            console.error('Erro ao carregar categorias:', error);
            NewsDispatch({
                type: ACTION_TYPES.setLoadingFilters,
                payload: false,
            });
        }
    }

    return {
        loadData,
        loadCategories
    };
}
